import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { Box, LinearProgress, FormGroup, Chip, Grid, Button } from "@material-ui/core";
import * as Yup from 'yup';

import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";

import AppUtil from "../../../../utilities/AppUtil";
import AppButton from "../../../../components/CustomButtons/AppButton";
import AppColor from "../../../../utilities/AppColor";
import AppConfirmDialog from "../../../../components/Dialog/AppConfirmDialog";
import AppTable from "../../../Admin/Component/Table/AppTable";
import TablePaginationActions from "../../../Admin/Component/Table/TablePaginationActions";
import { fetchListPayroll, reduceSubmitPayroll, reduceAddPayroll } from "store/slices/payroll";
import { fetchWorkerListByPayroll } from "store/slices/worker";

import { PAYROLL_STATUS } from "config/AppConfig";
import AppDialog from "components/Dialog/AppDialog";
import { Field, Form, Formik } from "formik";
import CustomDatePicker from "components/Input/CustomDatePicker";
import moment from "moment-timezone";

import SaveMoneyIcon from "assets/icons/save-money.svg";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import SelectField from "components/Select/SelectField";
import AppSelect from "components/Select/AppSelect";
import { getAuthInfo } from "store/slices/auth";
import { ACCOUNTING_TYPE } from "config/AppConfig";
import AppConfig from "config/AppConfig";


const useStyles = makeStyles({
  control: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    marginTop: '1rem'
  },
  input: {
    margin: '0.5rem 0',
    minHeight: 42,
    width: '100%',
    '&:hover': {
      borderColor: AppColor.mainColor
    },
    '&:focus': {
      borderColor: AppColor.mainColor
    },
    '& .react-daterange-picker__wrapper': {
      borderColor: AppColor.mainColor,
      borderRadius: 4,
      borderWidth: 2,
      padding: '0 0.5rem'
    },
    '& .react-daterange-picker__inputGroup': {
      textAlign: 'center'
    }
  },
  itemIcon: {
    minWidth: 24
  },
  disabled: {
    opacity: 0.3
  }
});

const headCells = [
  {
    id: "startedDate",
    numeric: "left",
    disablePadding: false,
    label: "label.startDate",
    sort: true,
  },
  {
    id: "endDate",
    numeric: "left",
    disablePadding: false,
    label: "label.endDate",
    sort: true,
  },
  {
    id: "staffName",
    numeric: "left",
    disablePadding: false,
    label: "label.staffName",
    sort: true,
  },
  {
    id: "totalPrice",
    numeric: "left",
    disablePadding: false,
    label: "label.total",
    sort: true,
  },
  {
    id: "status",
    numeric: "left",
    disablePadding: false,
    label: "label.status",
    sort: true,
  },
  {
    id: "actions",
    numeric: "center",
    disablePadding: false,
    label: "label.actions",
    sort: false,
  },
];

const PayrollTable = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [queries, setQueries] = useState({
    sort: true,
    page_number: 1,
    page_size: 10,
    search_key: "",
    sort_field: "name",
  });
  // const userList = useSelector(getUserCoordinatorList);
  const userInfo = useSelector(getAuthInfo);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [data, setData] = useState([]);
  const [listWorker, setListWorker] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [dateRange, setDateRange] = useState();
  const [selectedPayrollId, setSelectedPayrollId] = useState();

  const emptyRows = data.length === 0;

  const { accountingType } = userInfo;

  const statusOptions = accountingType === ACCOUNTING_TYPE.QUICKBOOKS ? PAYROLL_STATUS.map(item => {
    if (item !== 'PAID') {
      return {
        value: item,
        label: t(`payrollStatus.${item}`)
      }
    } else {
      return;
    }
  }).filter((item) => item !== undefined) : PAYROLL_STATUS.map(item => {
    if (item !== 'PAID_QB') {
      return {
        value: item,
        label: t(`payrollStatus.${item}`)
      }
    } else {
      return;
    }
  }).filter((item) => item !== undefined);

  const loadWorker = async () => {
    const result = await dispatch(fetchWorkerListByPayroll());
    if (result && result.payload) {
      setListWorker(result.payload);
    }
  };

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page_number: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page_number: 1,
      page_size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };

  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sort_field: property,
      sort:
        property === queries.sort_field ? queries.sort !== true : true,
    });
  };

  const _loadData = async ({ page_number, page_size, search_key, sort, sort_field, status, worker_id, dateRange } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page_number) {
      newQueries.page_number = page_number;
    }
    if (page_size) {
      newQueries.page_size = page_size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    if (status === "" || status) {
      newQueries.payroll_status = status;
    }
    if (worker_id === "" || worker_id) {
      newQueries.worker_id = worker_id;
    }
    if (dateRange) {
      setDateRange(dateRange);
      newQueries.start_date = moment(dateRange[0]).format('YYYY/MM/DD');
      newQueries.end_date = moment(dateRange[1]).format('YYYY/MM/DD');
    } else {
      setDateRange(null);
      delete newQueries.start_date;
      delete newQueries.end_date;
    }
    newQueries.search_key = search_key || "";
    newQueries.sort = !(!sort || false);
    setLoading(true);
    dispatch(fetchListPayroll(newQueries))
      .then(({ payload }) => {
        setQueries(newQueries);
        setLoading(false);
        if (payload) {
          setData(payload.content);
          setTotalElements(payload.totalElements);
        }
      });
  };

  useEffect(() => {
    _loadData();
    loadWorker();
  }, []);

  // eslint-disable-next-line react/prop-types
  const renderSelectField = ({ name, placeholder, options }) => (
    <AppSelect
      name={name}
      placeholder={t(placeholder)}
      options={options}
      onChange={option => {
        const params = {};
        if (option) {
          params[name] = option.value;
          _loadData(params);
        } else {
          params[name] = '';
          _loadData(params);
        }
      }}
      allowOverflow={true}
    />
  );

  const handleAddPayroll = async (data) => {

    const startDate = AppUtil.formatDate(data.startDate, 'yyyy/MM/DD');
    const endDate = AppUtil.formatDate(data.endDate, 'yyyy/MM/DD');

    data = { ...data, startDate, endDate };

    setSubmitting(true);
    const { payload } = await dispatch(reduceAddPayroll(data));
    setSubmitting(false);
    if (payload) {
      setShowCreateModal(false);
      _loadData();
    }
  };

  const handleSelectPayroll = (payrollId) => {
    setSelectedPayrollId(payrollId);
    setShowConfirmModal(true);
  }

  const handleSubmitPayroll = async () => {
    await dispatch(reduceSubmitPayroll({ id: selectedPayrollId }));
    setShowConfirmModal(false);
    _loadData();
  }

  return (
    <Box>
      <div>
        <AppButton
          label={t('label.createPayroll')}
          onClick={() => setShowCreateModal(true)}
        />
      </div>
      <Box my={2}>
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            <DateRangePicker
              onChange={(value) => _loadData({ dateRange: value })}
              // placeholder={placeholder}
              format={AppConfig.DATE_FORMAT.RANGE_PICKER}
              yearPlaceholder={'yyyy'}
              monthPlaceholder={'MM'}
              dayPlaceholder={'dd'}
              value={dateRange}
              className={classes.input}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            {
              renderSelectField({
                name: 'status',
                placeholder: "label.status",
                options: statusOptions
              })
            }
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            {
              renderSelectField({
                name: 'worker_id',
                placeholder: "label.staff",
                options: listWorker.map(item => {
                  return {
                    value: item.id,
                    label: `${item.firstName} ${item.lastName} (${item.email})`
                  }
                })
              })
            }
          </Grid>
        </Grid>
      </Box>
      <AppTable
        onRequestSort={onRequestSort}
        order={queries.sort === true ? "asc" : "desc"}
        orderBy={queries.sort_field}
        rowCount={data.length}
        headCells={headCells}
      >
        <TableBody>
          {loading && (<TableRow>
            <TableCell colSpan={7} padding="none">
              <LinearProgress />
            </TableCell>
          </TableRow>)}
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{AppUtil.formatDate(row.startDate, AppConfig.DATE_FORMAT.DEFAULT)}</TableCell>
              <TableCell>{AppUtil.formatDate(row.endDate, AppConfig.DATE_FORMAT.DEFAULT)}</TableCell>
              <TableCell>{row.staffName}</TableCell>
              <TableCell>{`$${AppUtil.formatMoney(row.totalPrice.toFixed(2))}`}</TableCell>
              <TableCell>
                <Chip
                  style={{
                    backgroundColor: (row.payrollStatus === 'PAID' || row.payrollStatus === 'PAID_QB')
                      ? AppColor.green
                      : AppColor.red,
                    color: AppColor.white
                  }}
                  size="small"
                  label={t(`payrollStatus.${row.payrollStatus}`)}
                />
              </TableCell>
              <TableCell>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box flex="1 0 0px" textAlign="right">
                    <Button
                      variant="text"
                      style={{
                        minWidth: 'unset'
                      }}
                      onClick={() => handleSelectPayroll(row.id)}
                      disabled={row.payrollStatus !== "NOT_YET"}
                      className={classNames({
                        [classes.disabled]: row.payrollStatus !== "NOT_YET"
                      })}
                    >
                      <img
                        src={SaveMoneyIcon}
                        className={classNames({
                          [classes.itemIcon]: true
                        })}
                      />
                    </Button>
                  </Box>
                  <Box flex="1 0 0px" className="text-right">
                    <Button
                      variant="text"
                      onClick={() => history.push(`/admin/payroll/${row.id}`)}
                      style={{
                        minWidth: 'unset'
                      }}>
                      <i className="fas fa-edit" />
                    </Button>
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length + 1} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.page_size}
              page={queries.page_number - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count:
                    count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
      <AppDialog
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        title={t('label.createPayroll')}
        maxWidth={'sm'}
      >
        <Formik
          initialValues={{
            startDate: '',
            endDate: '',
            workerId: ''
          }}
          onSubmit={handleAddPayroll}
          enableReinitialize
          validationSchema={Yup.object().shape({
            workerId: Yup.string().trim().required('validation.required'),
            startDate: Yup.date().required('validation.required')
              .when('endDate', (endDate, schema) => {
                if (endDate && endDate !== '') {
                  return schema.max(
                    moment(endDate).subtract(1, 'minutes').format('yyyy/MM/DD HH:mm'),
                    "validation.startTimeMustBeBeforeEndTime"
                  )
                }
              }),
            endDate: Yup.date().required('validation.required')
              .when('startTime', (startDate, schema) => {
                if (startDate && startDate !== '') {
                  return schema.min(
                    moment(startDate).add(1, 'minutes').format('yyyy/MM/DD HH:mm'),
                    "validation.endTimeMustBeAfterStartTime"
                  )
                }
              })
          },
            [
              ["startDate", "endDate"],
              ["endDate", "startDate"]
            ]
          )}
        >
          {() => (
            <Form>
              <Field
                component={SelectField}
                name="workerId"
                label={"label.worker"}
                options={listWorker.map(item => {
                  return {
                    value: item.id,
                    label: `${item.firstName} ${item.lastName} (${item.email})`
                  }
                })}
                required
              />
              <Field
                component={CustomDatePicker}
                name="startDate"
                label={"label.startDate"}
                required
                placeholder={'dd/MM/yyyy'}
                formatDateJob={true}
                custom={{
                  format: 'MM/DD/yyyy',
                  maxDate: moment().add(-1, 'days').toDate()
                }}
              />
              <Field
                component={CustomDatePicker}
                name="endDate"
                label={"label.endDate"}
                placeholder={'dd/MM/yyyy'}
                formatDateJob={true}
                required
                custom={{
                  format: 'MM/DD/yyyy',
                  maxDate: moment().add(-1, 'days').toDate()
                }}
              />
              <FormGroup className={classes.control}>
                <AppButton
                  label={t('label.back')}
                  mode="outlined"
                  onClick={() => setShowCreateModal(false)}
                  style={{ marginRight: "0.5rem" }}
                />
                <AppButton
                  label={t('button.save')}
                  type="submit"
                  disabled={submitting}
                  isLoading={submitting}
                />
              </FormGroup>
            </Form>
          )}
        </Formik>
      </AppDialog>
      <AppConfirmDialog
        open={showConfirmModal}
        onConfirm={() => handleSubmitPayroll()}
        onClose={() => setShowConfirmModal(false)}
        title={t('title.submitPayroll')}
        content={t('text.submitPayroll')}
      />
    </Box>
  );
};

export default PayrollTable;
